
import React from 'react';
import './index.scss';

import { ReactComponent as TuringLogo } from "../../../../../assets/img/turing_logo_text.svg";
import Aicpa from "../../../../../assets/img/homeV2Footer/aicpasoc.png";
import { talentPortalLinks, resourcesLinks, companyLinks, connectLinks, sitemapLinks, socialLinks } from './copy';

const TuringFooterV2 = React.memo(({ history }) => {

    const navigateToPage = (event, page) => {
        event.preventDefault();
        history.push(page);
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    };

    const navigateToExternalPage = (event, page) => {
        event.preventDefault();
        window.open(page, '_blank');
    };

    return (
        <div className='home-page-v2-footer'>
            <div className='home-page-v2-footer__content'>
                <div className='home-page-v2-footer__content__logo'>
                    <TuringLogo />
                </div>
                <div className='home-page-v2-footer__content__links'>
                    <div className='home-page-v2-footer__content__links__talent-portal'>
                        <p>Talent Portal</p>
                        <ul role='navigation' aria-label='Footer Links'>
                            {talentPortalLinks.map((link, index) => (
                                <li key={index}>
                                    <a aria-label={link.label}
                                        onClick={(event) => { navigateToPage(event, link.page); }}
                                    >{link.label}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className='home-page-v2-footer__content__links__resources'>
                        <p>Resources</p>
                        <ul role='navigation' aria-label='Footer Links'>
                            {resourcesLinks.map((link, index) => (
                                <li key={index}>
                                    <a aria-label={link.label}
                                        onClick={(event) => { navigateToExternalPage(event, link.page); }}
                                    >{link.label}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className='home-page-v2-footer__content__links__company__wrapper'>
                        <div className='home-page-v2-footer__content__links__company__wrapper__company'>
                            <p>Company</p>
                            <ul role='navigation' aria-label='Footer Links'>
                                {companyLinks.map((link, index) => (
                                    <li key={index}>
                                        <a aria-label={link.label}
                                            onClick={(event) => { navigateToExternalPage(event, link.page); }}
                                        >{link.label}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className='home-page-v2-footer__content__links__company__wrapper__connect'>
                            <p>Connect</p>
                            <ul role='navigation' aria-label='Footer Links'>
                                {connectLinks.map((link, index) => (
                                    <li key={index}>
                                        <a aria-label={link.label}
                                            onClick={(event) => { navigateToExternalPage(event, link.page); }}
                                        >{link.label}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className='home-page-v2-footer__others'>
                <div className='home-page-v2-footer__others__site-map'>
                    <div className='home-page-v2-footer__others__site-map__line'></div>
                    <div className='home-page-v2-footer__others__site-map__content'>
                        <div className='home-page-v2-footer__others__site-map__content__links'>
                            <div className='home-page-v2-footer__others__site-map__content__links__content'>
                                <ul role='navigation' aria-label='Footer Links'>
                                    {sitemapLinks.map((link, index) => (
                                        <li key={index}>
                                            <a aria-label={link.label}
                                                onClick={(event) => { navigateToExternalPage(event, link.page); }}
                                            >{link.label}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className='home-page-v2-footer__others__site-map__content__links__social'>
                                {socialLinks.map((link, index) => (
                                    <a
                                        key={index}
                                        href={link.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={link.style}
                                    >
                                        {link.icon}
                                    </a>
                                ))}
                            </div>
                        </div>
                        <img src={Aicpa} alt='Aicpa' />
                    </div>
                </div>
                <div className='home-page-v2-footer__others__legal'>
                    <p>1900 Embarcadero Road Palo Alto, CA, 94303</p>
                    <p>© {(new Date()).getFullYear()} Turing</p>
                </div>
            </div>
        </div>
    );
});

export default TuringFooterV2;
